export default "__VITE_ASSET__c611215e__"